// Optional kind of a card, shown as a coloured stripe and icon so a plan
// can be read at a glance (where are the breaks, where is group work).
// The icons live in CardTypeIcon.js and the names in i18n/messages.js
// (cardTypes.*), so this stays importable from plain helpers and their
// unit tests.
export const CARD_TYPES = {
  break: { color: "#B08A3E" },
  input: { color: "#3E6E82" },
  work: { color: "#4F7A52" },
  discussion: { color: "#7A4F7A" },
  workout: { color: "#A4513A" },
};

// Words an assistant (or a person writing a link) may use for each type,
// in English and German.
const TYPE_ALIASES = {
  break: ["break", "pause", "lunch", "coffee", "mittag", "kaffee"],
  input: ["input", "talk", "presentation", "lecture", "vortrag", "impuls"],
  work: [
    "work",
    "groupwork",
    "group work",
    "group",
    "exercise",
    "workshop",
    "gruppenarbeit",
    "übung",
  ],
  discussion: [
    "discussion",
    "discuss",
    "q&a",
    "qa",
    "questions",
    "diskussion",
    "austausch",
  ],
  workout: [
    "workout",
    "training",
    "sport",
    "cardio",
    "strength",
    "interval",
    "kraft",
    "ausdauer",
  ],
};

// Returns the CARD_TYPES key for a type name, or null if it isn't known.
export function parseCardType(value) {
  if (typeof value !== "string") {
    return null;
  }
  const text = value.trim().toLowerCase();
  return (
    Object.keys(TYPE_ALIASES).find((key) => TYPE_ALIASES[key].includes(text)) ||
    null
  );
}
